import { useContext, useState } from "react";
import appStyles from "../../../App.module.css";
import { BusinessTravelContext } from "../../BusinessTravel";
import { btCurrencyProductIds, getProduct } from "../../config/bt-constants";
import { IBusinessTravelContext, IinitialQuote } from "../../config/interfaces";
import Popup from "../Popup";
import LoadingModal from "../modal/LoadingModal";

type EditCurrencyAndCompanyProps = {
  itemsArray: any[];
  closeModel: React.Dispatch<React.SetStateAction<boolean>>;
  type: string;
};
const EditCurrencyAndCompany = (Props: EditCurrencyAndCompanyProps) => {
  const { itemsArray, closeModel, type } = Props;

  const { quoteData, loader, version, setLoader, createQuote, setQuoteResult, setQuoteData } = useContext(
    BusinessTravelContext
  ) as IBusinessTravelContext;

  const [initialValue, setInitialValue] = useState<any>(quoteData[type]);

  return (
    <div className={appStyles.formRow}>
      <div className={appStyles.formBlock}>
        <label className={` ${appStyles.btSubTitle}`}>
          {type === "noOfEmployee" ? "Number of employees at company" : "Preferred currency"}
        </label>

        <div className={`${appStyles.formField}`}>
          <div
            className={`${appStyles.formField} ${appStyles.btFormField}
          `}
          >
            {itemsArray?.map((item, index) => (
              <div
                key={index}
                className={`${appStyles.radioButton} ${type === "noOfEmployee" ? appStyles.radioButtonSmall : ""} `}
              >
                <input
                  type="radio"
                  id={item.value}
                  name={type}
                  value={item.value}
                  defaultChecked={item.value === quoteData[type]}
                  onChange={(e) => {
                    setInitialValue(e.target.value);
                    if (type === "currency") {
                      setQuoteData((prevQuoteData: IinitialQuote) => ({
                        ...prevQuoteData,
                        productId: version === "UK" ? getProduct(e.target.value) : btCurrencyProductIds?.BTEUProductId,
                      }));
                    }
                  }}
                />
                <label className="btn btn-default" htmlFor={item.value}>
                  {item.value}
                </label>
              </div>
            ))}
          </div>

          <div className={`${appStyles.btQuoteBtnWrap}`}>
            <button className={`${appStyles.btQuoteBtnOutline}`} onClick={() => closeModel(false)}>
              Cancel
            </button>
            <button
              className={`${appStyles.btQuoteBtn}`}
              onClick={async () => {
                try {
                  setLoader("trip");

                  const updatedField = type === "noOfEmployee" ? "noOfEmployee" : "currency";
                  const _quoteData = {
                    ...quoteData,
                    [updatedField]: initialValue,
                  };
                  closeModel(false);
                  const createQuoteResponse = await createQuote(_quoteData);
                  setQuoteResult(createQuoteResponse);
                  setQuoteData(_quoteData);
                } catch (error) {
                  console.log(error);
                } finally {
                  setLoader(null);
                }
              }}
              type="button"
            >
              Save
              {loader && (
                <Popup
                  onClose={() => {}}
                  title=""
                  children={<LoadingModal />}
                  closeButton={false}
                  LoadingModal={true}
                />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCurrencyAndCompany;
